import { Directive, AfterContentInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import service from '../data/services/services.json';
import category from '../data/services/category.json';

@Directive()
export class ServiceHelperService implements AfterContentInit {
  page: number = 1;
  public serviceblock = service;
  public servicedetails = service;
  constructor(private route: ActivatedRoute) { }
  // Category
  public getCategories(items: string | any[]) {
    var elems = category.filter((item: { id: string; }) => {
      return items.includes(item.id)
    });
    return elems;
  }
  // Service Details
  public setService(id: any) {
    this.servicedetails = service.filter((item: { id: any; }) => { return item.id == id });
  }
  ngAfterContentInit(): void {
    this.setService(this.route.snapshot.params.id);
  }
  // Service Navigation
  public serviceNavigation(items: string | any[], index: number) {
    var output = [],
      id, item;
    if (items[index - 1] !== undefined && index - 1 !== -1) {
      item = items[index - 1];
      id = item.id;
      // Show the previous button 
      output.push("<div class='sigma_single-pagination-item sigma_single-pagination-prev'> <a href='/service-details/" + item.id + "'> <i class='far fa-arrow-left'></i><div class='sigma_single-pagination-content'><h6>" + item.title.slice(0, 25) + "</h6> <span>Prev Project</span></div> </a></div>");
    }
    if (items[index + 1] !== undefined && index <= items.length - 1) {
      // Show next button 
      item = items[index + 1];
      id = item.id;
      output.push("<div class='sigma_single-pagination-item sigma_single-pagination-next'> <a href='/service-details/" + item.id + "'><div class='sigma_single-pagination-content'><h6>" + item.title.slice(0, 25) + "</h6> <span>Next Project</span></div> <i class='far fa-arrow-right'></i> </a></div>");
    }

    return output;
  }
}
